var map = {
	"./about-bg-example-1.jpg": 112,
	"./about-bg-example-2.png": 113,
	"./art/art-sample-1.2.png": 114,
	"./art/art-sample-1.png": 115,
	"./art/art-sample-2.png": 116,
	"./art/art-sample-3.png": 117,
	"./art/art-sample-4.png": 118,
	"./art/art-sample-5.png": 119,
	"./art/art-sample-6.png": 120,
	"./header-sample.png": 121,
	"./logo.png": 122,
	"./nikaleles/about.png": 123,
	"./nikaleles/avatar.png": 124,
	"./nikaleles/header.png": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;